/* @flow */

export default ({ children }: { children?: any }) => {
  return children;
};



// WEBPACK FOOTER //
// ./src/ui/components/chrome/PageLayout.js